import { useState, useEffect, useRef } from "react";
import Bredcrum from '../../components/bredcrum';
import { Toast } from "primereact/toast";
import { Tablescom } from '../../components/tablescomp';
import { productservices } from '../../services/productServices';
import { Titlebar, Searchbox, Confirmdelete } from '../../components/fieldsComp';
import { BrowserRouter, Routes, Route, useNavigate } from "react-router";
import { Dialog } from 'primereact/dialog';
import {localurl} from '../../constant';
import {convertFileToBase64} from '../../helpers/base64conversion';
import { TabMenu } from 'primereact/tabmenu';

const Componentsindex = () =>{
const toast = useRef(null);
    const navigate = useNavigate();
    const [users,setUsers] = useState([]);
    const [results,setResults] = useState([]);
    const [userloaded,setUserloaded] = useState(true);
    const [visible,setVisible] = useState(false);
    const [popvisible,setPopvisible] = useState(false);
    const [deleleteid,setDeleleteid] = useState(0);
    const [viewcomponent,setViewcomponent] = useState([]);
    const [viewvisible,setViewvisible] = useState(false);
    const [quickFilterText, setQuickFilterText] = useState('');
    const [totalRows, setTotalRows] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10); // 🔄 dynamic page size
    const [activeIndex, setActiveIndex] = useState(0);
    
    useEffect(()=>{
      // console.log('view component'); 
      // console.log(viewcomponent);
    },[]) 
    
    useEffect(()=>{
          getcomponents(currentPage,pageSize,'all');
    },[currentPage,pageSize]); 


  useEffect(() => {
    getcomponents(currentPage, pageSize);
  }, [currentPage, pageSize]);

  useEffect(() => {
    setColDefs(getColDefs(currentPage, pageSize));
  }, [currentPage, pageSize]);

  const handleNext = () => {
    if (currentPage < Math.ceil(totalRows / pageSize)) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const getColDefs = (currentPage, pageSize) => [
    {
      headerName: "SR NO",
      width: 100,
      valueGetter: (params) => {
        return ((currentPage - 1) * pageSize) + params.node.rowIndex + 1;
      },
    },
    { headerName: "Component", field: "component" },
    { headerName: "Sku", field: "componentSkuCode" },
    // { headerName: "Component Type",field: "componentType",cellRenderer: (params) => {
    //     return (
    //         <Tag severity="success" value={params.getValue()} rounded></Tag>

    //     );
    //   } },
    // { headerName: "Description",field: "description" },
    { headerName: "Supplier", field: "supplier_name" },
    {
      headerName: "Units in Stock", field: "qty_produced",
      cellRenderer: (params) => {
        return (
          <>
            <div className="flex-box"><span>{params.data.qty_produced}</span> &nbsp;<span className="text-success">({params.data.unit})</span></div>
          </>
        );
      }
    },
    {
      headerName: "Action",
      headerClass: "header-action", 
      cellRenderer: (params) => {
        // console.log("params");
        // console.log(params.data.id);
        return (
          <>
            <button class="btn  btn-xs btn-white custom-btn-color2" onClick={(e) => editredirect(params.data.id, params.data)}><i class="icon icon-note  color-white"></i></button>
            {/* <button class="btn btn-danger btn-sm btn-white btn-border-none"><i class="icon icon-trash txt-error icon-style"></i></button>  */}
            {/* <button class="btn  btn-sm btn-white custom-btn-color2" onClick={(e) => editredirect(params.data.id,params.data)}><i class="icon icon-note icon-style color-white"></i></button> */}
            &nbsp;
            <button class="btn  btn-danger btn-xs btn-white btn-border-none" onClick={(e) => deletecomponents(params.data.id)}><i class="icon icon-trash color-white"></i></button>
            &nbsp;
            <button class="btn btn-success btn-xs btn-white btn-border-none" onClick={(e) => viewcomponents(params.data.id)}><i class="icon icon-eye color-white"></i></button>



          </>

        );
      }
    }
  ];

  const [colDefs, setColDefs] = useState(getColDefs(1, 5));

  const viewcomponents = (id) => {
    productservices.getsinglecomponents(id).then((response) => {
      if (response.status == 200) {
        setViewcomponent(response.data.data);
      }
    }).catch((error) => {

    });
  }

  useEffect(()=>{
      setViewvisible(true);
      console.log('view component');
      console.log(viewcomponent);
  },[viewcomponent])

  const deletecomponentdata = () => {
    if (deleleteid) {
      productservices.deletecomponents(deleleteid).then((response) => {
        if (response.status == 200) {
          setPopvisible(false);
          setDeleleteid(false);
          toast.current.show({ severity: 'success', summary: 'Sale', detail: 'Components deleted successfully' });
          getcomponents(currentPage, pageSize);
        }
      }).catch((error) => {

      });
    }

  }
  const deletecomponents = (id) => {
    setPopvisible(true);
    setDeleleteid(id);
  }


  const editredirect = (id, Data) => {
    navigate(`/editcomponent/${id}`, { state: { supplier: Data } });
  }


  const getcomponents = (page, pageSize) => {
    setUserloaded(true);
    productservices.getcomponents(page, pageSize).then((response) => {
      if (response.status == 200) {
        console.warn(response.data);
        setResults(response.data.data);
        setTotalRows(response.data.total);
        setCurrentPage(response.data.current_page);
        setUserloaded(false);
      } else {
        setResults([]);
        setUserloaded(false);
      }
    }).catch((error) => {
      setResults([]);
      setUserloaded(false);
    });
  }

  const addproductnavigate = () => {
    // navigate.  
    navigate('/addingredient');
  }

  const uploadcomponent = async (e) => {
    e.preventDefault();
    let file = e.target.file.files[0];
    const base64 = await convertFileToBase64(file);
    productservices.createmulticomponent(base64).then((response) => {
      if (response.status == 200) {
        setVisible(false);
        toast.current.show({ severity: 'success', summary: 'Component', detail: response.data.data });

      } else {
        toast.current.show({ severity: 'error', summary: 'Component', detail: `${response.data.data}` });
      }
    }).catch((error) => {

    });
  }

  const onPaginationChanged = (params) => {
    const gridApi = params.api;
    const newPage = gridApi.paginationGetCurrentPage() + 1;
    if (newPage !== currentPage) {
      setCurrentPage(newPage);
    }
  };

  const handlePageSizeChange = (e) => {
    const newSize = parseInt(e.target.value);
    setPageSize(newSize);
    setCurrentPage(1);           // reset to page 1
    getcomponents(1, newSize);       // reload with new size
  };

  const canceldiag = () => {
    setPopvisible(false);
  }
  return (
    <>
      <Toast ref={toast} />
      <Confirmdelete popvisible={popvisible} deletefun={deletecomponentdata} cancel={canceldiag} title="Component" />

      <Dialog
        header="Component Data View"
        visible={viewvisible}
        style={{ width: '60vw' }}
        onHide={() => setViewvisible(false)}
        // footer={footerContent}
        modal
        className="p-fluid"
      >
        <div className="card-body">
          <div className="container mt-4">
            {viewcomponent.map((row, index) => (
              <div className="row" key={index}>
                <div className="col-md-6 form-group">
                  <label>Component</label>
                  <input className="form-control" type="text" value={row.component || ''} readOnly />
                </div>

                <div className="col-md-6 form-group">
                  <label>Component SKU Code</label>
                  <input className="form-control" type="text" value={row.componentSkuCode || ''} readOnly />
                </div>

                <div className="col-md-6 form-group">
                  <label>Component Type</label>
                  <select className="form-control" value={row.componentType || ''} disabled>
                    <option>{row.componentType}</option>
                  </select>
                </div>

                <div className="col-md-6 form-group">
                  <label>Description</label>
                  <input className="form-control" type="text" value={row.description || ''} readOnly />
                </div>

                <div className="col-md-6 form-group">
                  <label>Supplier</label>
                  <select className="form-control" value={row.supplier || ''} disabled>
                    <option>{row.supplier}</option>
                  </select>
                </div>

                <div className="col-md-6 form-group">
                  <label>Cost</label>
                  <div className="d-flex gap-2">
                    <select className="form-control" style={{ width: '80px' }} value={row.cost_currency || ''} disabled>
                      <option>{row.cost_currency}</option>
                    </select>
                    <input className="form-control" type="text" value={row.cost || ''} readOnly />
                  </div>
                </div>

                <div className="col-md-6 form-group">
                  <label>Stock Level</label>
                  <input className="form-control" type="text" value={row.stockLevel || ''} readOnly />
                </div>

                <div className="col-md-6 form-group">
                  <label>Freight Charges</label>
                  <input className="form-control" type="text" value={row.freightCharges || ''} readOnly />
                </div>

                <div className="col-md-6 form-group">
                  <label>Unit of Measurement</label>
                  <select className="form-control" value={row.unitOfMeasurement || ''} disabled>
                    <option>{row.unitOfMeasurement}</option>
                  </select>
                </div>

                <div className="col-md-6 form-group">
                  <label>Superdrug SKU Code</label>
                  <input className="form-control" type="text" value={row.superdrugSkuCode || ''} readOnly />
                </div>

                <div className="col-md-12 form-group">
                  <label>Notes</label>
                  <textarea className="form-control" readOnly>{row.notes || ''}</textarea>
                </div>

                <div className="col-md-6 form-group">
                  <label>Supplier Cost</label>
                  <div className="d-flex gap-2">
                    <select className="form-control" style={{ width: '80px' }} value={row.supplier_currency || ''} disabled>
                      <option>{row.supplier_currency}</option>
                    </select>
                    <input className="form-control" type="text" value={row.supplier_cost || ''} readOnly />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </Dialog>


      {/* <Bredcrum title={'Components'} divider={false} /> */}
      <div class="row">
        <div className='col-md-12 mb-2 mt-2'>
          <div className='flex-box flex-between'>
            <div>
              <button className='btn btn-primary rounded-pill custom-btn-color custom-btn-br-color ps-4 pe-4' style={{ marginRight: "10px" }} onClick={() => navigate('/addcomponent')}>Add Component</button>
              <button className='btn rounded-pill ps-4 pe-4 btn-dark' onClick={() => setVisible(true)}>Add Multi Components</button>
            </div>
            <Searchbox value={quickFilterText} onChange={(e) => setQuickFilterText(e.target.value)} />
          </div>

        </div>


        <Dialog visible={visible} position='top' modal style={{ width: '50rem' }} onHide={() => { if (!visible) return; setVisible(false); }}>
          <div className="container py-5">
            <div className="card shadow-lg rounded-4 p-4">
              <h2 className="mb-4 text-center text-primary">Excel Multiple Data Upload</h2>

              <div className="text-center mb-4">
                <a
                  href={localurl + "/templates/component.xlsx"}
                  download
                  className="btn btn-outline-primary rounded-pill px-4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Download Excel Template
                </a>
              </div>

              <form id="uploadForm" onSubmit={(e) => uploadcomponent(e)}>
                <div className="mb-3">
                  <label htmlFor="file" className="form-label fw-semibold">
                    Upload Excel File
                  </label>
                  <input
                    type="file"
                    className="form-control form-control-lg"
                    id="file"
                    name="file"
                    accept=".xlsx, .xls"
                    required
                  />
                </div>

                <div className="text-center">
                  <button
                    type="submit"
                    className="btn btn-primary rounded-pill px-5 py-2 custom-btn-color"
                  >
                    Upload
                  </button>
                </div>
              </form>

              <div id="status" className="status mt-4 text-center text-success fw-medium"></div>
            </div>
          </div>

        </Dialog>


        {/* <Titlebar text={'Components'} /> */}


        <div className="col-md-12 mt-3">
          <div className='card'>
            <div className='card-body card-body-style'>
              <Tablescom rowdata={results} coldefs={colDefs} isloaded={userloaded} quickFilterText={quickFilterText}
                paginationPageSize={pageSize} onPaginationChanged={onPaginationChanged}
                totalRows={totalRows} currentPage={currentPage} pageSize={pageSize} handleNext={handleNext}
                handlePrevious={handlePrevious}
                handlePageSizeChange={handlePageSizeChange} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Componentsindex;